module.exports = __webpack_public_path__ + "static/theme-editor-top-categories-c895ee21e3905a2272090c7351a38dcf.png";